import {
  StyleSymbolType,
  isTwoDimensionalSymbol,
  isSizableSymbol,
  isPolylineSymbols,
  isSvgPointSymbol,
  isH3GridSymbol,
} from "../../../interfaces/style";
import { getParameterValue } from "../classification/getFromClassified";
import { getParameterFromSymbol } from "../classification/getParameterFromStyle";
import { getSymbolStrokeWidth } from "../symbol/getSymbolStrokeWidth";

const EXTRA_BORDER_SIZE = 4;

const DEFAULT_LEGEND_SYMBOL_SIZE = 26;

export const getLegendSymbolSize = (symbol: StyleSymbolType): number => {
  let size = 0;

  if (isSvgPointSymbol(symbol)) {
    size = getParameterValue(symbol.size);
  }

  if (isH3GridSymbol(symbol)) {
    size = getParameterValue(symbol.cellSize);
  }

  if (isTwoDimensionalSymbol(symbol)) {
    size = Math.max(getParameterValue(symbol.width), getParameterValue(symbol.height));
  }

  if (isSizableSymbol(symbol)) {
    const strokeWidth = getSymbolStrokeWidth(symbol);

    size = getParameterValue(symbol.size) + (strokeWidth ? getParameterValue(strokeWidth) + EXTRA_BORDER_SIZE : 0);
  }

  if (isPolylineSymbols(symbol)) {
    size = getParameterValue(getParameterFromSymbol(symbol, "stroke.width")) as number;
  }

  return Math.max(DEFAULT_LEGEND_SYMBOL_SIZE, size);
};
